import { useQuery } from '@tanstack/react-query';

import axios from 'axios';

import { WeatherWallWindowRelations } from 'types';

export const getWeatherWalls = async (
  userId: number | undefined
): Promise<WeatherWallWindowRelations[]> => {
  if (userId === undefined) return [];
  const response = await axios.get(`/api/users/${userId}/weather-walls`);
  return response.data as WeatherWallWindowRelations[];
};

export const useWeatherWalls = <T extends any = WeatherWallWindowRelations[]>(
  userId: number | undefined,
  select?: (data: WeatherWallWindowRelations[]) => T
) => {
  return useQuery({
    queryKey: ['weatherWalls', 'user', userId],
    queryFn: () => getWeatherWalls(userId),
    select: select,
  });
};
